var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__TEMP__SVG__",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__2",
    "data-name": "__TEMP__SVG__",
    d: "M27.14,7.785,21.62,3.2,20.06,5.046l5.52,4.585Zm-16.98-2.8L8.6,3.14,3.14,7.785,4.7,9.632l5.46-4.645Zm5.58,5.479h-1.8v7.146l5.7,3.395.9-1.489-4.8-2.8V10.465ZM15.14,5.7A10.72,10.72,0,1,0,25.94,16.42,10.753,10.753,0,0,0,15.14,5.7Zm0,19.057a8.338,8.338,0,1,1,8.4-8.338A8.393,8.393,0,0,1,15.14,24.758Z",
    transform: "translate(-3.14 -3.14)",
    fill: "#8a8a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.0c66e7dd73183deb2eafb4c0a0a8051c.svg";
export { ForwardRef as ReactComponent };